export default __webpack_public_path__ + "static/media/Crystal4xLogo.c8f2fdc2.png";